import React from "react";
import { Col, Container, Row } from "reactstrap";
import { useRef, useState } from "react";
import CriticalIllnessTabImage from "../../Assets/Images/critical-illness-tab-image.jpg";
import { useAnimateOnScroll } from "../../Hooks/useAnimationScroll";
import CoveredFull from "./CoveredFull";
import CoveredHalf from "./CoveredHalf";
import { useTranslation } from "../../Hooks/useTranslation"; // Import the hook

const componentMap = {
  COVEREDFULL: <CoveredFull />,
  COVEREDHALF: <CoveredHalf />,
};
const CriticalIllnessTab = () => {
  const translations = useTranslation(); // Get translations dynamically
  useAnimateOnScroll();

  const [change, setChange] = useState("COVEREDFULL");

  return (
    <div
      id="critical-illness-covered"
      className="supeior-rating py-20 lg:pb-36 lg:mb-36 mb-12"
    >
      <div className="relative lg:absolute w-[100%] lg:w-[50%] pr-[20px] left-0 lg:block hidden">
        <div className="flex-1 w-[100%] flex-none !ml-auto ms-[5%] mt-[5%] md:mt-0 order-first lg:order-last">
          <div className="ml-[20px] lg:ml-0 mb-[10%] md:mb-0 max-h-[688px] animate__animated animate__fadeInLeft">
            <img
              src={CriticalIllnessTabImage}
              width={"100%"}
              className="object-cover rounded-br-[600px] rounded-tr-[600px] max-h-[860px]"
              alt="not found"
            />
          </div>
        </div>
      </div>
      <Container>
        <div className="">
          <div className=" animate__animated  mt-0 lg:mt-28 lg:ml-[50%] animate__fadeInLeft  lg:pl-[5rem] critical-illness-covered-header">
            <h3 className="text-[24px] md:text-[40px] mb-2 md:leading-[44px] leading-[28px]  font-semibold   max-w-[530px] lg:mb-5 mb-4 lg:pr-0 pr-10 extra-title-heading">
              {translations.criticalIllnessTab1.heading}
            </h3>
            <hr class="bordertitle-line mb-4"></hr>
            <div className="active-section flex lg:justify-center justify-space-between  bg-white rounded-full lg:mt-7 mt-12 mb-4 md:max-w-[530px] max-w-[281px]">
              <button
                onClick={() => setChange("COVEREDFULL")}
                className={`md:flex-1 content text-[12px] extra-btn-font ${
                  change === "COVEREDFULL"
                    ? "active bg-[#FFE9B1] font-semibold"
                    : ""
                } font-medium  ${
                  change === "COVEREDFULL" ? "text-black" : "text-black"
                } py-3 px-4 rounded-full md:w-1/3`}
              >
                {translations.criticalIllnessTab1.coveredFull}
              </button>
              <button
                onClick={() => setChange("COVEREDHALF")}
                className={`md:flex-1 content text-[12px] extra-btn-font ${
                  change === "COVEREDHALF"
                    ? "active bg-[#FFE9B1] font-semibold"
                    : ""
                } font-medium  ${
                  change === "COVEREDHALF" ? "text-black" : "text-black"
                } py-3 px-4 rounded-full md:w-1/3`}
              >
                {translations.criticalIllnessTab1.coveredHalf}
              </button>
            </div>
            {componentMap[change] || null}
          </div>
        </div>
      </Container>
    </div>
  );
};

export default CriticalIllnessTab;
